module.exports = __webpack_public_path__ + "img/filter-left.f2221fcd.svg";